<h1 class="title sr-only" translate>HOMEPAGE.RENEW.TITLE</h1>
<app-page-wrapper>
  <ng-ui-kit-card
    type="outlined"
    [data]="true"
    [noAction]="true"
    className="renew-summary-card">
    <div class="renew-summary-body" data>
      <div class="renew-summary-header">
        <div class="under-title" translate>RENEW_PAGE.UNDER_TITLE</div>
        <div
          class="expiring-date"
          [innerHTML]="
            'RENEW_PAGE.EXPIRING_DATE'
              | translate
                : {
                    date: expiringDate,
                  }
          "></div>
      </div>
      <div class="desc" translate>RENEW_PAGE.DESC</div>
      <div class="under-desc" translate>RENEW_PAGE.UNDER_DESC</div>

      <div class="renew-options">
        <ng-ui-kit-card
          *ngIf="!onlyRAOpayment"
          type="summative"
          iconLeft="firma"
          [title]="'RENEW_PAGE.CARDS.SHOP.TITLE' | translate"
          [text]="'RENEW_PAGE.CARDS.SHOP.DESC' | translate"
          [button]="shopCardButton"
          [noAction]="true"
          className="renew-option-card renew-option-card--with-desc renew-option-card--firma">
        </ng-ui-kit-card>
        <ng-ui-kit-card
          *ngIf="
            !session.trissUser &&
            (needsPayment || !noPayment || onlyRAOpayment)
          "
          type="summative"
          iconLeft="badge"
          [title]="'RENEW_PAGE.CARDS.RAO.TITLE' | translate"
          [button]="raoCardButton"
          [noAction]="true"
          className="renew-option-card renew-option-card--compact">
        </ng-ui-kit-card>
        <ng-ui-kit-card
          *ngIf="(needsPayment || !noPayment) && !onlyRAOpayment"
          type="summative"
          iconLeft="group"
          [title]="'RENEW_PAGE.CARDS.COUPON.TITLE' | translate"
          [button]="couponCardButton"
          [noAction]="true"
          className="renew-option-card renew-option-card--compact">
        </ng-ui-kit-card>
      </div>
    </div>
  </ng-ui-kit-card>
</app-page-wrapper>

<!-- RENEW MODAL -->
<app-common-modal
  modalId="renew-modal"
  [title]="'RENEW_PAGE.BUTTON.SIGN' | translate"
  [(visible)]="renewModalVisible"
  [config]="{ size: 'lg', persistent: true, hideButtons: true }"
  (onClose)="onToggleRenewModal(false)">
  <ng-container *ngIf="renderRenewModalContent">
    <div *ngIf="!showSpinner && !isNewFlow">
      <!-- CONTRACT-SIGN FORM -->
      <form [formGroup]="contractSignForm" (ngSubmit)="onContractSignSubmit()">
        <!-- CONTRACT-SIGN STEP -->
        <div class="ic1-mt-24 ic1-mb-16">
          <ng-ui-kit-accordion
            [disabled]="!showContractSignStep"
            [title]="'RENEW_PAGE.CONTRACT_SIGN_STEP.TITLE' | translate"
            [open]="showContractSignStep"
            [icon]="
              !showContractSignStep &&
              (showContractSignOTP ||
                showAuthorizationStep ||
                showPassphraseStep ||
                showEmissionStep ||
                showEmissionOTP)
                ? 'check'
                : ''
            "
            [step]="showContractSignStep ? contractSignStepNumber : 0">
            <ng-container content>
              <div class="ic1-row">
                <div
                  class="desc ic1-col-12"
                  [innerHTML]="
                    'RENEW_PAGE.CONTRACT_SIGN_STEP.DESC_PERSONAL_INFORMATION'
                      | translate
                        : {
                            nome: nome,
                            iut: iut,
                            date: expiringDateTextFormat,
                          }
                  "></div>
                <div class="checkbox-container ic1-col-12 ic1-mt-16">
                  <ng-ui-kit-checkbox
                    #ConditionsCheckbox
                    icId="c15"
                    [label]="''"
                    [error]="contractSignGeneralConsentAttempted && !isGeneralConditionsChecked"
                    dimension="large"
                    (change)="checkDataConfirmation($event, 'general')">
                  </ng-ui-kit-checkbox>
                  <span
                    [innerHTML]="
                      'RENEW_PAGE.CONTRACT_SIGN_STEP.CONTRACT_CONDITION'
                        | translate
                    "></span>
                </div>
                <div class="desc ic1-col-12" translate>
                  RENEW_PAGE.CONTRACT_SIGN_STEP.DESC_CONFIRM
                </div>
                <div
                  class="checkbox-container ic1-col-12 ic1-mt-16 checkBoxCss">
                  <ng-ui-kit-checkbox
                    #ConfirmCheckbox
                    icId="c16"
                    [label]="''"
                    [error]="contractSignPersonalConsentAttempted && !isPersonalDataChecked"
                    dimension="large"
                    (change)="checkDataConfirmation($event, 'personal')">
                  </ng-ui-kit-checkbox>
                  <span
                    [innerHTML]="
                      'RENEW_PAGE.CONTRACT_SIGN_STEP.I_CONFIRM' | translate
                    "></span>
                </div>
                <div
                  *ngIf="
                    codiceFiscaleControl.errors &&
                    uuidControl.errors &&
                    !isPkBoxOnPkBox
                  "
                  class="desc ic1-col-12"
                  [innerHTML]="
                    'RENEW_PAGE.CONTRACT_SIGN_STEP.UUID_REPLACEMENT_NOTICE'
                      | translate
                  "></div>
                <div
                  *ngIf="
                    codiceFiscaleControl.errors &&
                    uuidControl.errors &&
                    !isPkBoxOnPkBox
                  "
                  class="checkbox-container ic1-col-12 ic1-mt-16 checkBoxCss">
                  <ng-ui-kit-checkbox
                    #UuidReplacementNoticeCheckbox
                    icId="c17"
                    [label]="''"
                    [error]="contractSignUuidConsentAttempted && !isUuidNoticeChecked"
                    dimension="large"
                    (change)="checkDataConfirmation($event, 'uuidNotice')">
                  </ng-ui-kit-checkbox>
                  <span
                    [innerHTML]="
                      'RENEW_PAGE.CONTRACT_SIGN_STEP.I_CONFIRM' | translate
                    "></span>
                </div>

                <div class="w-100"></div>
                <div class="ic1-col-12 buttons-container">
                  <ng-ui-kit-button
                    color="secondary"
                    [label]="'COMMON.BUTTON.CANCEL' | translate"
                    type="button"
                    size="sm"
                    (onClick)="closeModal()">
                  </ng-ui-kit-button>
                  <ng-ui-kit-button
                    color="primary"
                    [disabled]="loading"
                    [label]="'COMMON.BUTTON.CONFIRM' | translate"
                    type="button"
                    size="sm"
                    (onClick)="goToContractSignOTP()">
                  </ng-ui-kit-button>
                </div>
              </div>
            </ng-container>
          </ng-ui-kit-accordion>
        </div>
        <!-- FINE CONTRACT SIGN STEP -->
        <!-- CONTRACT-SIGN OTP STEP START -->
        <div class="ic1-my-16">
          <ng-ui-kit-accordion
            [disabled]="!showContractSignOTP"
            [title]="'COMMON.ACCORDION_AUTHENTICATION.TITLE' | translate"
            [open]="showContractSignOTP"
            [icon]="
              !showContractSignOTP &&
              (showAuthorizationStep ||
                showPassphraseStep ||
                showEmissionStep ||
                showEmissionOTP)
                ? 'check'
                : ''
            "
            [step]="
              showAuthorizationStep ||
              showPassphraseStep ||
              showEmissionStep ||
              showEmissionOTP
                ? 0
                : contractSignStepNumber + 1
            ">
            <ng-container content>
              <ng-ui-kit-toast
                *ngIf="isPkBox"
                class="ic1-col-12 ic1-mb-12 renew-warning-toast"
                status="warning"
                [text]="
                  (shouldSkipContractSignOtp
                    ? 'RENEW_PAGE.CONTRACT_SIGN_STEP.PIN_ATTENTION_NO_OTP'
                    : 'RENEW_PAGE.CONTRACT_SIGN_STEP.PIN_ATTENTION'
                  ) | translate
                ">
              </ng-ui-kit-toast>
              <div class="ic1-col-12 ic1-col-lg-6 input">
                <app-pin-input
                  formControlName="pin"
                  [labelKey]="'RENEW_PAGE.CONTRACT_SIGN_STEP.PIN_LABEL'"
                  [length]="8"
                  [hideValue]="true"
                  [error]="contractSignPinAttempted && pin.invalid"
                  [errorDisclaimerText]="getContractSignPinErrorDisclaimerText()"
                  (onUserInput)="contractSignPinAttempted = false"
                >
                </app-pin-input>
              </div>
              <div class="ic1-col-12" *ngIf="!shouldSkipContractSignOtp">
                <ng-ui-kit-separator
                  class="renew-auth-separator"></ng-ui-kit-separator>
              </div>
              <div class="ic1-col-12" *ngIf="!shouldSkipContractSignOtp">
                <div class="ic1-form-group">
                  <app-otp-input
                    resetGroup="sms"
                    [startTimer]="showContractSignOTP"
                      formControlName="otp"
                      [error]="
                        !isOtpFormatValid(fContractSign['otp'].value) &&
                        contractSignOtpAttempted
                      "
                      [errorDisclaimerText]="getContractSignOtpErrorDisclaimerText()"
                      (onUserInput)="contractSignOtpAttempted = false"
                    ></app-otp-input>
                </div>
              </div>
              <div class="buttons-container ic1-mt-16">
                <ng-ui-kit-button
                  color="secondary"
                  [label]="'COMMON.BUTTON.CANCEL' | translate"
                  type="button"
                  size="sm"
                  (onClick)="goToContractSignStep()">
                </ng-ui-kit-button>
                <app-submit-button
                  type="submit"
                  [loading]="loading"
                  [disabled]="loading"
                  [label]="'COMMON.BUTTON.CONFIRM' | translate"
                  translate-key="COMMON.BUTTON.CONFIRM"
                  (onClick)="onContractSignSubmit()"></app-submit-button>
              </div>
            </ng-container>
          </ng-ui-kit-accordion>
        </div>
      </form>
      <!-- AUTHORIZATION STEP-->
      <div *ngIf="needsPayment || noPayment === false">
        <!-- RAO -->
        <form
          [formGroup]="raoForm"
          *ngIf="paymentMode === 'RAO'"
          (ngSubmit)="onRAOsubmit()">
          <div class="ic1-my-16">
            <ng-ui-kit-accordion
              [disabled]="!showAuthorizationStep"
              [title]="'RENEW_PAGE.AUTH_RAO_STEP.TITLE' | translate"
              [open]="showAuthorizationStep"
              [icon]="
                !showAuthorizationStep &&
                (showPassphraseStep || showEmissionStep || showEmissionOTP)
                  ? 'check'
                  : ''
              "
              [step]="
                showPassphraseStep || showEmissionStep || showEmissionOTP
                  ? 0
                  : authorizationStepNumber
              ">
              <ng-container content>
                <div class="ic1-row">
                  <div class="desc ic1-col-12 ic1-mb-16" translate>
                    RENEW_PAGE.AUTH_RAO_STEP.DESC
                  </div>
                  <div class="ic1-col-12 ic1-col-lg-6 input">
                    <ng-ui-kit-input
                      formControlName="username"
                      name="username"
                      autocomplete="username"
                      [placeholder]="
                        'RENEW_PAGE.AUTH_RAO_STEP.USERNAME_PLACEHOLDER'
                          | translate
                      "
                      type="text"
                      icName="username"
                      icId="username"
                      [label]="
                        'RENEW_PAGE.AUTH_RAO_STEP.USERNAME_LABEL' | translate
                      "
                      [status]="
                        raoAttempted && username.invalid
                          ? 'error'
                          : 'informative'
                      ">
                    </ng-ui-kit-input>
                    <app-field-validator
                      *ngIf="raoAttempted"
                      [field]="username"
                      [formErrors]="raoFormErrors"></app-field-validator>
                  </div>
                  <div class="ic1-col-12 ic1-col-lg-6 input">
                    <ng-ui-kit-input
                      formControlName="password"
                      name="password"
                      autocomplete="password"
                      [placeholder]="
                        'RENEW_PAGE.AUTH_RAO_STEP.PASSWORD_PLACEHOLDER'
                          | translate
                      "
                      type="password"
                      icName="password"
                      icId="password"
                      [label]="
                        'RENEW_PAGE.AUTH_RAO_STEP.PASSWORD_LABEL' | translate
                      "
                      [status]="
                        raoAttempted && password.invalid
                          ? 'error'
                          : 'informative'
                      ">
                    </ng-ui-kit-input>
                    <app-field-validator
                      *ngIf="raoAttempted"
                      [field]="password"
                      [formErrors]="raoFormErrors"></app-field-validator>
                  </div>
                  <div class="w-100"></div>
                  <div class="ic1-col-12 buttons-container ic1-mt-16">
                    <ng-ui-kit-button
                      color="secondary"
                      [label]="'COMMON.BUTTON.CANCEL' | translate"
                      type="button"
                      size="sm"
                      (onClick)="closeModal()">
                    </ng-ui-kit-button>
                    <ng-ui-kit-button
                      color="primary"
                      [disabled]="loading"
                      [label]="'COMMON.BUTTON.CONFIRM' | translate"
                      type="button"
                      size="sm"
                      (onClick)="onRAOsubmit()">
                    </ng-ui-kit-button>
                  </div>
                </div>
              </ng-container>
            </ng-ui-kit-accordion>
          </div>
        </form>
        <!-- COUPON -->
        <form
          [formGroup]="couponForm"
          *ngIf="paymentMode === 'COUPON'"
          (ngSubmit)="onCouponSubmit()">
          <div class="ic1-my-16">
            <ng-ui-kit-accordion
              [disabled]="!showAuthorizationStep"
              [title]="'RENEW_PAGE.COUPON_STEP.TITLE' | translate"
              [open]="showAuthorizationStep"
              [icon]="
                !showAuthorizationStep &&
                (showPassphraseStep || showEmissionStep || showEmissionOTP)
                  ? 'check'
                  : ''
              "
              [step]="
                showPassphraseStep || showEmissionStep || showEmissionOTP
                  ? 0
                  : authorizationStepNumber
              ">
              <ng-container content>
                <div class="ic1-row">
                  <div class="desc ic1-col-12 ic1-mb-16" translate>
                    RENEW_PAGE.COUPON_STEP.DESC
                  </div>
                  <div class="ic1-col-12 ic1-col-lg-6 input">
                    <ng-ui-kit-input
                      formControlName="coupon"
                      name="coupon"
                      autocomplete="coupon"
                      [placeholder]="
                        'RENEW_PAGE.COUPON_STEP.COUPON_PLACEHOLDER' | translate
                      "
                      type="text"
                      icName="coupon"
                      icId="coupon"
                      minlength="3"
                      [label]="
                        'RENEW_PAGE.COUPON_STEP.COUPON_LABEL' | translate
                      "
                      [status]="
                        couponAttempted && coupon.invalid
                          ? 'error'
                          : 'informative'
                      ">
                    </ng-ui-kit-input>
                    <app-field-validator
                      *ngIf="couponAttempted"
                      [field]="coupon"
                      [formErrors]="couponFormErrors"></app-field-validator>
                  </div>
                  <div class="ic1-col-12 buttons-container ic1-mt-16">
                    <ng-ui-kit-button
                      color="secondary"
                      [label]="'COMMON.BUTTON.CANCEL' | translate"
                      type="button"
                      size="sm"
                      (onClick)="closeModal()">
                    </ng-ui-kit-button>
                    <ng-ui-kit-button
                      color="primary"
                      [disabled]="loading"
                      [label]="'COMMON.BUTTON.CONFIRM' | translate"
                      type="button"
                      size="sm"
                      (onClick)="onCouponSubmit()">
                    </ng-ui-kit-button>
                  </div>
                </div>
              </ng-container>
            </ng-ui-kit-accordion>
          </div>
        </form>
        <!-- SHOP (NEGOZIO INFOCERT) -->
        <div
          *ngIf="
            paymentMode === 'SHOP' &&
            (noPayment === false || needsPayment === true)
          ">
          <div class="ic1-my-16">
            <ng-ui-kit-accordion
              [disabled]="!showAuthorizationStep"
              [title]="'RENEW_PAGE.SHOP_STEP.TITLE' | translate"
              [open]="showAuthorizationStep"
              [icon]="
                !showAuthorizationStep &&
                (showPassphraseStep || showEmissionStep || showEmissionOTP)
                  ? 'check'
                  : ''
              "
              [step]="
                showPassphraseStep || showEmissionStep || showEmissionOTP
                  ? 0
                  : authorizationStepNumber
              ">
              <ng-container content>
                <div class="ic1-row">
                  <div
                    class="ic1-col-12"
                    *ngIf="!redirectingToShop; else redirectLoading">
                    <div class="ic1-col-12 ic1-mb-16">
                      <div
                        class="desc"
                        [innerHTML]="
                          'RENEW_PAGE.SHOP_STEP.DESC' | translate
                        "></div>
                      <div
                        class="shop-desc-2"
                        [innerHTML]="
                          'RENEW_PAGE.SHOP_STEP.DESC_2' | translate
                        "></div>
                    </div>
                    <div class="ic1-col-12 buttons-container ic1-mt-16">
                      <ng-ui-kit-button
                        color="secondary"
                        [label]="'COMMON.BUTTON.CANCEL' | translate"
                        type="button"
                        size="sm"
                        (onClick)="closeModal()">
                      </ng-ui-kit-button>
                      <ng-ui-kit-button
                        color="primary"
                        [disabled]="loading"
                        [label]="
                          'RENEW_PAGE.SHOP_STEP.PROCEED_TO_PAYMENT' | translate
                        "
                        type="button"
                        size="sm"
                        (onClick)="onShopSubmit()">
                      </ng-ui-kit-button>
                    </div>
                  </div>
                  <ng-template class="ic1-col-12" #redirectLoading>
                    <div class="hourglass-container ic1-col-12">
                      <!-- <img
                        class="hourglass"
                        src="assets/images/redirect-icon.png" /> -->
                      <img
                        class="hourglass"
                        src="assets/images/hourglass.svg" />
                      <div
                        class="first-msg"
                        [HTMLTranslate]="
                          'RENEW_PAGE.SHOP_STEP.REDIRECT_TO_SHOP'
                        "></div>
                      <div
                        class="second-msg"
                        [HTMLTranslate]="'RENEW_PAGE.SHOP_STEP.WAIT'"></div>
                    </div>
                  </ng-template>
                </div>
              </ng-container>
            </ng-ui-kit-accordion>
          </div>
        </div>
      </div>
      <!-- PASSPHRASE STEP -->
      <form
        *ngIf="followMigrationFlow || session.trissUser"
        [formGroup]="passphraseForm"
        (ngSubmit)="onPassphraseSubmit()">
        <div class="ic1-my-16">
          <ng-ui-kit-accordion
            [disabled]="!showPassphraseStep"
            [title]="'RENEW_PAGE.PASSPHRASE_STEP.TITLE' | translate"
            [open]="showPassphraseStep"
            [icon]="
              !showPassphraseStep && (showEmissionStep || showEmissionOTP)
                ? 'check'
                : ''
            "
            [step]="
              showEmissionStep || showEmissionOTP ? 0 : passphraseStepNumber
            ">
            <ng-container content>
              <div class="ic1-row">
                <div class="desc ic1-col-12" translate>
                  RENEW_PAGE.PASSPHRASE_STEP.DESC
                </div>
                <div class="ic1-col-12 ic1-mt-16" *ngIf="CF !== ''">
                  <ng-ui-kit-checkbox
                    icId="c17"
                    [label]="'RENEW_PAGE.PASSPHRASE_STEP.CF_LABEL' | translate"
                    dimension="large"
                    (change)="setCF($event)">
                  </ng-ui-kit-checkbox>
                </div>

                <div class="w-100"></div>

                <div class="ic1-col-12 ic1-col-lg-6 input">
                  <ng-ui-kit-input
                    formControlName="passphrase"
                    name="passphrase"
                    autocomplete="passphrase"
                    [placeholder]="
                      'RENEW_PAGE.PASSPHRASE_STEP.PASSPHRASE_LABEL' | translate
                    "
                    type="text"
                    icName="passphrase"
                    icId="passphrase"
                    [label]="
                      'RENEW_PAGE.PASSPHRASE_STEP.PASSPHRASE_LABEL' | translate
                    "
                    [status]="
                      passphraseAttempted && passphrase.invalid
                        ? 'error'
                        : 'informative'
                    ">
                  </ng-ui-kit-input>
                  <app-field-validator
                    *ngIf="passphraseAttempted"
                    [field]="passphrase"
                    [formErrors]="passphraseFormErrors"></app-field-validator>
                </div>

                <div class="ic1-col-12 buttons-container">
                  <ng-ui-kit-button
                    color="secondary"
                    [label]="'COMMON.BUTTON.CANCEL' | translate"
                    type="button"
                    size="sm"
                    (onClick)="closeModal()">
                  </ng-ui-kit-button>
                  <ng-ui-kit-button
                    color="primary"
                    [disabled]="loading"
                    [label]="'COMMON.BUTTON.CONFIRM' | translate"
                    type="button"
                    size="sm"
                    (onClick)="onPassphraseSubmit()">
                  </ng-ui-kit-button>
                </div>
              </div>
            </ng-container>
          </ng-ui-kit-accordion>
        </div>
      </form>
      <!-- EMISSION STEP -->
      <form [formGroup]="emissionForm" (ngSubmit)="onEmissionSubmit()">
        <div class="ic1-my-16">
          <ng-ui-kit-accordion
            [disabled]="!showEmissionStep"
            [title]="'RENEW_PAGE.EMISSION_STEP.TITLE' | translate"
            [open]="showEmissionStep"
            [icon]="!showEmissionStep && showEmissionOTP ? 'check' : ''"
            [step]="showEmissionOTP ? 0 : emissionStepNumber">
            <ng-container content>
              <div class="ic1-row">
                <div
                  class="desc ic1-col-12 ic1-mb-16"
                  [innerHTML]="'RENEW_PAGE.EMISSION_STEP.DESC' | translate"
                  style="white-space: pre-line"></div>
                <div class="ic1-col-12 ic1-col-lg-6 input">
                <app-pin-input
                  formControlName="newPin"
                  [labelKey]="'RENEW_PAGE.EMISSION_STEP.PIN_PLACEHOLDER'"
                  [length]="8"
                  [hideValue]="true"
                  [error]="emissionPinAttempted && newPin.invalid"
                  (onUserInput)="emissionPinAttempted = false"
                  resetGroup="contract-pin">
                </app-pin-input>
                  <app-field-validator
                    *ngIf="emissionPinAttempted"
                    [field]="newPin"
                    [formErrors]="emissionFormErrors"></app-field-validator>
                </div>

                <div class="ic1-col-12 ic1-col-lg-6">
                <app-confirm-pin-input
                  formControlName="confirmPin"
                  [labelKey]="'RENEW_PAGE.EMISSION_STEP.CONFIRM_PIN_PLACEHOLDER'"
                  [length]="8"
                  [hideValue]="true"
                  [error]="emissionPinAttempted && confirmPin.invalid"
                  (onUserInput)="emissionPinAttempted = false"
                  resetGroup="contract-pin">
                </app-confirm-pin-input>
                  <app-field-validator
                    *ngIf="emissionPinAttempted"
                    [field]="confirmPin"
                    [formErrors]="emissionFormErrors"></app-field-validator>
                </div>

                <div
                  *ngIf="
                    emissionFormErrors?.['samePassword'] &&
                    hasEmissionPinsAtMinLength() &&
                    (newPin.dirty ||
                      newPin.touched ||
                      confirmPin.dirty ||
                      confirmPin.touched)
                  "
                  class="ic1-col-12 error error-icon">
                  <div translate="COMMON.VALIDATORS.PIN_MISMATCH"></div>
                </div>

                <div class="ic1-col-12 buttons-container ic1-mt-12">
                  <ng-ui-kit-button
                    color="secondary"
                    [label]="'COMMON.BUTTON.CANCEL' | translate"
                    type="button"
                    size="sm"
                    (onClick)="closeModal()">
                  </ng-ui-kit-button>
                  <ng-ui-kit-button
                    color="primary"
                    [disabled]="loading"
                    [label]="
                      'RENEW_PAGE.EMISSION_STEP.ACTIVATE_CERT' | translate
                    "
                    type="button"
                    size="sm"
                    (onClick)="goToEmissionOTP()">
                  </ng-ui-kit-button>
                </div>
              </div>
            </ng-container>
          </ng-ui-kit-accordion>
        </div>
        <!-- EMISSION OTP STEP START  -->
        <div
          *ngIf="!followMigrationFlow && !(isPkBox && automatic)"
          class="ic1-my-16">
          <ng-ui-kit-accordion
            [disabled]="!showEmissionOTP"
            [title]="'COMMON.ACCORDION_OTP.TITLE' | translate"
            [open]="showEmissionOTP"
            [step]="emissionStepNumber + 1">
            <ng-container content>
              <div class="ic1-row">
                <div class="ic1-col-12 desc ic1-mb-12" translate>
                  COMMON.ACCORDION_OTP.DESC
                </div>
                <div class="ic1-col-12">
                  <div class="ic1-form-group">
                    <app-otp-input
                      resetGroup="sms"
                      [startTimer]="showEmissionOTP"
                      formControlName="otp"
                      [error]="
                        !isOtpFormatValid(fEmission['otp'].value) &&
                        emissionOtpAttempted
                      "
                      [errorDisclaimerText]="getEmissionOtpErrorDisclaimerText()"
                      (onUserInput)="emissionOtpAttempted = false"
                    ></app-otp-input>
                  </div>
                </div>
                <div class="ic1-col-12 buttons-container ic1-mt-16">
                  <ng-ui-kit-button
                    color="secondary"
                    [label]="'COMMON.BUTTON.CANCEL' | translate"
                    type="button"
                    size="sm"
                    (onClick)="goToEmissionStep()">
                  </ng-ui-kit-button>
                  <app-submit-button
                    type="submit"
                    [loading]="loading"
                    [disabled]="loading"
                    [label]="'COMMON.BUTTON.CONFIRM' | translate"
                    translate-key="COMMON.BUTTON.CONFIRM"></app-submit-button>
                </div>
              </div>
            </ng-container>
          </ng-ui-kit-accordion>
        </div>
      </form>
    </div>
    <div *ngIf="!showSpinner && isNewFlow">
      <!-- CONTRACT-SIGN FORM -->
      <form [formGroup]="contractSignForm" (ngSubmit)="onContractSignSubmit()">
        <!-- CONTRACT-SIGN STEP -->
        <div class="ic1-mt-24 ic1-mb-16">
          <ng-ui-kit-accordion
            [disabled]="!showContractSignStep"
            [title]="'RENEW_PAGE.CONTRACT_SIGN_STEP.TITLE' | translate"
            [open]="showContractSignStep"
            [icon]="
              !showContractSignStep &&
              (showContractSignOTP ||
                showAuthorizationStep ||
                showPassphraseStep ||
                showEmissionStep ||
                showEmissionOTP)
                ? 'check'
                : ''
            "
            [step]="showContractSignStep ? contractSignStepNumber : 0">
            <ng-container content>
              <div class="ic1-row">
                <div
                  class="desc ic1-col-12"
                  [innerHTML]="
                    'RENEW_PAGE.CONTRACT_SIGN_STEP.DESC_PERSONAL_INFORMATION'
                      | translate
                        : {
                            nome: nome,
                            iut: iut,
                            date: expiringDateTextFormat,
                          }
                  "></div>
                <div class="checkbox-container ic1-col-12 ic1-mt-16">
                  <ng-ui-kit-checkbox
                    #ConditionsCheckbox
                    icId="c15"
                    [label]="''"
                    [error]="contractSignGeneralConsentAttempted && !isGeneralConditionsChecked"
                    dimension="large"
                    (change)="checkDataConfirmation($event, 'general')">
                  </ng-ui-kit-checkbox>
                  <span
                    [innerHTML]="
                      'RENEW_PAGE.CONTRACT_SIGN_STEP.CONTRACT_CONDITION'
                        | translate
                    "></span>
                </div>
                <div class="desc ic1-col-12" translate>
                  RENEW_PAGE.CONTRACT_SIGN_STEP.DESC_CONFIRM
                </div>
                <div
                  class="checkbox-container ic1-col-12 ic1-mt-16 checkBoxCss">
                  <ng-ui-kit-checkbox
                    #ConfirmCheckbox
                    icId="c16"
                    [label]="''"
                    [error]="contractSignPersonalConsentAttempted && !isPersonalDataChecked"
                    dimension="large"
                    (change)="checkDataConfirmation($event, 'personal')">
                  </ng-ui-kit-checkbox>
                  <span
                    [innerHTML]="
                      'RENEW_PAGE.CONTRACT_SIGN_STEP.I_CONFIRM' | translate
                    "></span>
                </div>
                <div
                  *ngIf="
                    codiceFiscaleControl.errors &&
                    uuidControl.errors &&
                    !isPkBoxOnPkBox
                  "
                  class="desc ic1-col-12"
                  [innerHTML]="
                    'RENEW_PAGE.CONTRACT_SIGN_STEP.UUID_REPLACEMENT_NOTICE'
                      | translate
                  "></div>
                <div
                  *ngIf="
                    codiceFiscaleControl.errors &&
                    uuidControl.errors &&
                    !isPkBoxOnPkBox
                  "
                  class="checkbox-container ic1-col-12 ic1-mt-16 checkBoxCss">
                  <ng-ui-kit-checkbox
                    #UuidReplacementNoticeCheckbox
                    icId="c17"
                    [label]="''"
                    [error]="contractSignUuidConsentAttempted && !isUuidNoticeChecked"
                    dimension="large"
                    (change)="checkDataConfirmation($event, 'uuidNotice')">
                  </ng-ui-kit-checkbox>
                  <span
                    [innerHTML]="
                      'RENEW_PAGE.CONTRACT_SIGN_STEP.I_CONFIRM' | translate
                    "></span>
                </div>

                <div class="w-100"></div>
                <div class="ic1-col-12 buttons-container">
                  <ng-ui-kit-button
                    color="secondary"
                    [label]="'COMMON.BUTTON.CANCEL' | translate"
                    type="button"
                    size="sm"
                    (onClick)="closeModal()">
                  </ng-ui-kit-button>
                  <ng-ui-kit-button
                    color="primary"
                    [disabled]="loading"
                    [label]="'COMMON.BUTTON.CONFIRM' | translate"
                    type="button"
                    size="sm"
                    (onClick)="goToContractSignOTP()">
                  </ng-ui-kit-button>
                </div>
              </div>
            </ng-container>
          </ng-ui-kit-accordion>
        </div>
        <!-- FINE CONTRACT SIGN STEP -->
        <!-- CONTRACT-SIGN OTP STEP START -->
        <div class="ic1-my-16">
          <ng-ui-kit-accordion
            [disabled]="!showContractSignOTP"
            [title]="'COMMON.ACCORDION_AUTHENTICATION.TITLE' | translate"
            [open]="showContractSignOTP"
            [icon]="
              !showContractSignOTP &&
              (showAuthorizationStep ||
                showPassphraseStep ||
                showEmissionStep ||
                showEmissionOTP)
                ? 'check'
                : ''
            "
            [step]="
              showAuthorizationStep ||
              showPassphraseStep ||
              showEmissionStep ||
              showEmissionOTP
                ? 0
                : contractSignStepNumber + 1
            ">
            <ng-container content>
              <ng-ui-kit-toast
                *ngIf="isPkBox"
                class="ic1-col-12 ic1-mb-12 renew-warning-toast"
                status="warning"
                [text]="
                  (shouldSkipContractSignOtp
                    ? 'RENEW_PAGE.CONTRACT_SIGN_STEP.PIN_ATTENTION_NO_OTP'
                    : 'RENEW_PAGE.CONTRACT_SIGN_STEP.PIN_ATTENTION'
                  ) | translate
                ">
              </ng-ui-kit-toast>
              <div class="ic1-col-12 ic1-col-lg-6 input">
                <app-pin-input
                  formControlName="pin"
                  [labelKey]="'RENEW_PAGE.CONTRACT_SIGN_STEP.PIN_LABEL'"
                  [length]="8"
                  [hideValue]="true"
                  [error]="contractSignPinAttempted && pin.invalid"
                  [errorDisclaimerText]="getContractSignPinErrorDisclaimerText()"
                  (onUserInput)="contractSignPinAttempted = false"
                >
                </app-pin-input>
              </div>
              <div class="ic1-col-12" *ngIf="!shouldSkipContractSignOtp">
                <ng-ui-kit-separator
                  class="renew-auth-separator"></ng-ui-kit-separator>
              </div>
              <div class="ic1-col-12" *ngIf="!shouldSkipContractSignOtp">
                <div class="ic1-form-group">
                  <app-otp-input
                    resetGroup="sms"
                    [startTimer]="showContractSignOTP"
                    formControlName="otp"
                      [error]="
                        !isOtpFormatValid(fContractSign['otp'].value) &&
                        contractSignOtpAttempted
                      "
                    [errorDisclaimerText]="getContractSignOtpErrorDisclaimerText()"
                    (onUserInput)="contractSignOtpAttempted = false"
                  ></app-otp-input>
                </div>
              </div>
              <div class="buttons-container ic1-mt-16">
                <ng-ui-kit-button
                  color="secondary"
                  [label]="'COMMON.BUTTON.CANCEL' | translate"
                  type="button"
                  size="sm"
                  (onClick)="goToContractSignStep()">
                </ng-ui-kit-button>
                <app-submit-button
                  type="submit"
                  [loading]="loading"
                  [disabled]="loading"
                  [label]="'COMMON.BUTTON.CONFIRM' | translate"
                  translate-key="COMMON.BUTTON.CONFIRM"
                  (onClick)="onContractSignSubmit()"></app-submit-button>
              </div>
            </ng-container>
          </ng-ui-kit-accordion>
        </div>
      </form>
      <!-- PASSPHRASE STEP -->
      <form
        *ngIf="followMigrationFlow || session.trissUser"
        [formGroup]="passphraseForm"
        (ngSubmit)="onPassphraseSubmit()">
        <div class="ic1-my-16">
          <ng-ui-kit-accordion
            *ngIf="!(automatic && isPkBox)"
            [disabled]="!showPassphraseStep"
            [title]="'RENEW_PAGE.PASSPHRASE_STEP.TITLE' | translate"
            [open]="showPassphraseStep"
            [icon]="
              !showPassphraseStep && (showEmissionStep || showAuthorizationStep)
                ? 'check'
                : ''
            "
            [step]="
              showEmissionStep || showAuthorizationStep
                ? 0
                : passphraseStepNumber
            ">
            <ng-container content>
              <div class="ic1-row">
                <div class="desc ic1-col-12" translate>
                  RENEW_PAGE.PASSPHRASE_STEP.DESC
                </div>
                <div class="ic1-col-12 ic1-mt-16" *ngIf="CF !== ''">
                  <ng-ui-kit-checkbox
                    icId="c17"
                    [label]="'RENEW_PAGE.PASSPHRASE_STEP.CF_LABEL' | translate"
                    dimension="large"
                    (change)="setCF($event)">
                  </ng-ui-kit-checkbox>
                </div>

                <div class="w-100"></div>

                <div class="ic1-col-12 ic1-col-lg-6 input">
                  <ng-ui-kit-input
                    formControlName="passphrase"
                    name="passphrase"
                    autocomplete="passphrase"
                    [placeholder]="
                      'RENEW_PAGE.PASSPHRASE_STEP.PASSPHRASE_LABEL' | translate
                    "
                    type="text"
                    icName="passphrase"
                    icId="passphrase"
                    [label]="
                      'RENEW_PAGE.PASSPHRASE_STEP.PASSPHRASE_LABEL' | translate
                    "
                    [status]="
                      passphraseAttempted && passphrase.invalid
                        ? 'error'
                        : 'informative'
                    ">
                  </ng-ui-kit-input>
                  <app-field-validator
                    *ngIf="passphraseAttempted"
                    [field]="passphrase"
                    [formErrors]="passphraseFormErrors"></app-field-validator>
                </div>

                <div class="ic1-col-12 buttons-container">
                  <ng-ui-kit-button
                    color="secondary"
                    [label]="'COMMON.BUTTON.CANCEL' | translate"
                    type="button"
                    size="sm"
                    (onClick)="closeModal()">
                  </ng-ui-kit-button>
                  <ng-ui-kit-button
                    color="primary"
                    [disabled]="loading"
                    [label]="'COMMON.BUTTON.CONFIRM' | translate"
                    type="button"
                    size="sm"
                    (onClick)="onPassphraseSubmit()">
                  </ng-ui-kit-button>
                </div>
              </div>
            </ng-container>
          </ng-ui-kit-accordion>
        </div>
      </form>
      <!-- EMISSION STEP -->
      <form [formGroup]="emissionForm" (ngSubmit)="onEmissionSubmit()">
        <div class="ic1-my-16">
          <ng-ui-kit-accordion
            [disabled]="!showEmissionStep"
            [title]="'RENEW_PAGE.EMISSION_STEP.TITLE' | translate"
            [open]="showEmissionStep"
            [icon]="!showEmissionStep && showAuthorizationStep ? 'check' : ''"
            [step]="showAuthorizationStep ? 0 : emissionStepNumber">
            <ng-container content>
              <div class="ic1-row">
                <div
                  class="desc ic1-col-12 ic1-mb-16"
                  [innerHTML]="'RENEW_PAGE.EMISSION_STEP.DESC' | translate"
                  style="white-space: pre-line"></div>
                <div class="ic1-col-12 ic1-col-lg-6 input">
                <app-pin-input
                  formControlName="newPin"
                  [labelKey]="'RENEW_PAGE.EMISSION_STEP.PIN_PLACEHOLDER'"
                  [length]="8"
                  [hideValue]="true"
                  [error]="emissionPinAttempted && newPin.invalid"
                  (onUserInput)="emissionPinAttempted = false"
                  resetGroup="contract-pin">
                </app-pin-input>
                  <app-field-validator
                    *ngIf="emissionPinAttempted"
                    [field]="newPin"
                    [formErrors]="emissionFormErrors"></app-field-validator>
                </div>

                <div class="ic1-col-12 ic1-col-lg-6">
                <app-confirm-pin-input
                  formControlName="confirmPin"
                  [labelKey]="'RENEW_PAGE.EMISSION_STEP.CONFIRM_PIN_PLACEHOLDER'"
                  [length]="8"
                  [hideValue]="true"
                  [error]="emissionPinAttempted && confirmPin.invalid"
                  (onUserInput)="emissionPinAttempted = false"
                  resetGroup="contract-pin">
                </app-confirm-pin-input>
                  <app-field-validator
                    *ngIf="emissionPinAttempted"
                    [field]="confirmPin"
                    [formErrors]="emissionFormErrors"></app-field-validator>
                </div>

                <div
                  *ngIf="
                    emissionFormErrors?.['samePassword'] &&
                    hasEmissionPinsAtMinLength() &&
                    (newPin.dirty ||
                      newPin.touched ||
                      confirmPin.dirty ||
                      confirmPin.touched)
                  "
                  class="ic1-col-12 error error-icon">
                  <div translate="COMMON.VALIDATORS.PIN_MISMATCH"></div>
                </div>

                <div class="ic1-col-12 buttons-container ic1-mt-12">
                  <ng-ui-kit-button
                    color="secondary"
                    [label]="'COMMON.BUTTON.CANCEL' | translate"
                    type="button"
                    size="sm"
                    (onClick)="closeModal()">
                  </ng-ui-kit-button>
                  <app-submit-button
                    type="submit"
                    [loading]="loading"
                    [disabled]="loading"
                    [label]="
                      'RENEW_PAGE.EMISSION_STEP.ACTIVATE_CERT' | translate
                    "
                    (onClick)="onEmissionSubmit()">
                  </app-submit-button>
                </div>
              </div>
            </ng-container>
          </ng-ui-kit-accordion>
        </div>
      </form>
      <!-- AUTHORIZATION STEP-->
      <div *ngIf="needsPayment || noPayment === false">
        <!-- RAO -->
        <form
          [formGroup]="raoForm"
          *ngIf="paymentMode === 'RAO'"
          (ngSubmit)="onRAOsubmit()">
          <div class="ic1-my-16">
            <ng-ui-kit-accordion
              [disabled]="!showAuthorizationStep"
              [title]="'RENEW_PAGE.AUTH_RAO_STEP.TITLE' | translate"
              [open]="showAuthorizationStep"
              [icon]="
                renewalState === 'RENEWED' ||
                (!needsPayment && noPayment !== false)
                  ? 'check'
                  : ''
              "
              [step]="authorizationStepNumber">
              <ng-container content>
                <div class="ic1-row">
                  <div class="desc ic1-col-12 ic1-mb-16" translate>
                    RENEW_PAGE.AUTH_RAO_STEP.DESC
                  </div>
                  <div class="ic1-col-12 ic1-col-lg-6 input">
                    <ng-ui-kit-input
                      formControlName="username"
                      name="username"
                      autocomplete="username"
                      [placeholder]="
                        'RENEW_PAGE.AUTH_RAO_STEP.USERNAME_PLACEHOLDER'
                          | translate
                      "
                      type="text"
                      icName="username"
                      icId="username"
                      [label]="
                        'RENEW_PAGE.AUTH_RAO_STEP.USERNAME_LABEL' | translate
                      "
                      [status]="
                        raoAttempted && username.invalid
                          ? 'error'
                          : 'informative'
                      ">
                    </ng-ui-kit-input>
                    <app-field-validator
                      *ngIf="
                        raoAttempted && username.invalid
                      "
                      [field]="username"
                      [formErrors]="raoFormErrors"></app-field-validator>
                  </div>
                  <div class="ic1-col-12 ic1-col-lg-6 input">
                    <ng-ui-kit-input
                      formControlName="password"
                      name="password"
                      autocomplete="password"
                      [placeholder]="
                        'RENEW_PAGE.AUTH_RAO_STEP.PASSWORD_PLACEHOLDER'
                          | translate
                      "
                      type="password"
                      icName="password"
                      icId="password"
                      [label]="
                        'RENEW_PAGE.AUTH_RAO_STEP.PASSWORD_LABEL' | translate
                      "
                      [status]="
                        raoAttempted && password.invalid
                          ? 'error'
                          : 'informative'
                      ">
                    </ng-ui-kit-input>
                    <app-field-validator
                      *ngIf="
                        raoAttempted && password.invalid
                      "
                      [field]="password"
                      [formErrors]="raoFormErrors"></app-field-validator>
                  </div>
                  <div class="w-100"></div>
                  <div class="ic1-col-12 buttons-container ic1-mt-16">
                    <ng-ui-kit-button
                      color="secondary"
                      [label]="'COMMON.BUTTON.CANCEL' | translate"
                      type="button"
                      size="sm"
                      (onClick)="closeModal()">
                    </ng-ui-kit-button>
                    <app-submit-button
                      color="primary"
                      [loading]="loading"
                      [disabled]="loading"
                      [label]="'COMMON.BUTTON.CONFIRM' | translate"
                      type="button"
                      size="sm"
                      (onClick)="onRAOsubmit()">
                    </app-submit-button>
                  </div>
                </div>
              </ng-container>
            </ng-ui-kit-accordion>
          </div>
        </form>
        <!-- COUPON -->
        <form
          [formGroup]="couponForm"
          *ngIf="paymentMode === 'COUPON'"
          (ngSubmit)="onCouponSubmit()">
          <div class="ic1-my-16">
            <ng-ui-kit-accordion
              [disabled]="!showAuthorizationStep"
              [title]="'RENEW_PAGE.COUPON_STEP.TITLE' | translate"
              [open]="showAuthorizationStep"
              [icon]="
                renewalState === 'RENEWED' ||
                (!needsPayment && noPayment !== false)
                  ? 'check'
                  : ''
              "
              [step]="authorizationStepNumber">
              <ng-container content>
                <div class="ic1-row">
                  <div class="desc ic1-col-12 ic1-mb-16" translate>
                    RENEW_PAGE.COUPON_STEP.DESC
                  </div>
                  <div class="ic1-col-12 ic1-col-lg-6 input">
                    <ng-ui-kit-input
                      formControlName="coupon"
                      name="coupon"
                      autocomplete="coupon"
                      [placeholder]="
                        'RENEW_PAGE.COUPON_STEP.COUPON_PLACEHOLDER' | translate
                      "
                      type="text"
                      icName="coupon"
                      icId="coupon"
                      minlength="3"
                      [label]="
                        'RENEW_PAGE.COUPON_STEP.COUPON_LABEL' | translate
                      "
                      [status]="
                        couponAttempted && coupon.invalid
                          ? 'error'
                          : 'informative'
                      ">
                    </ng-ui-kit-input>
                    <app-field-validator
                      *ngIf="couponAttempted"
                      [field]="coupon"
                      [formErrors]="couponFormErrors"></app-field-validator>
                  </div>
                  <div class="ic1-col-12 buttons-container ic1-mt-16">
                    <ng-ui-kit-button
                      color="secondary"
                      [label]="'COMMON.BUTTON.CANCEL' | translate"
                      type="button"
                      size="sm"
                      (onClick)="closeModal()">
                    </ng-ui-kit-button>
                    <app-submit-button
                      color="primary"
                      [loading]="loading"
                      [disabled]="loading"
                      [label]="'COMMON.BUTTON.CONFIRM' | translate"
                      type="button"
                      size="sm"
                      (onClick)="onCouponSubmit()">
                    </app-submit-button>
                  </div>
                </div>
              </ng-container>
            </ng-ui-kit-accordion>
          </div>
        </form>
        <!-- SHOP (NEGOZIO INFOCERT) -->
        <div
          *ngIf="
            paymentMode === 'SHOP' &&
            (noPayment === false || needsPayment === true)
          ">
          <div class="ic1-my-16">
            <ng-ui-kit-accordion
              [disabled]="!showAuthorizationStep"
              [title]="'RENEW_PAGE.SHOP_STEP.TITLE' | translate"
              [open]="showAuthorizationStep"
              [icon]="
                renewalState === 'RENEWED' ||
                (!needsPayment && noPayment !== false)
                  ? 'check'
                  : ''
              "
              [step]="authorizationStepNumber">
              <ng-container content>
                <div class="ic1-row">
                  <div
                    class="ic1-col-12"
                    *ngIf="!redirectingToShop; else redirectLoading">
                    <div class="ic1-col-12 ic1-mb-16">
                      <div
                        class="desc"
                        [innerHTML]="
                          'RENEW_PAGE.SHOP_STEP.DESC_NEW_FLOW' | translate
                        "></div>
                    </div>
                    <div class="ic1-col-12 buttons-container ic1-mt-16">
                      <ng-ui-kit-button
                        color="secondary"
                        [label]="'COMMON.BUTTON.CANCEL' | translate"
                        type="button"
                        size="sm"
                        (onClick)="closeModal()">
                      </ng-ui-kit-button>
                      <ng-ui-kit-button
                        color="primary"
                        [disabled]="loading"
                        [label]="
                          'RENEW_PAGE.SHOP_STEP.COMPLETE_RENEWAL' | translate
                        "
                        [iconAfter]="'open_in_new'"
                        type="button"
                        size="sm"
                        (onClick)="onShopSubmit()">
                      </ng-ui-kit-button>
                    </div>
                  </div>
                  <ng-template class="ic1-col-12" #redirectLoading>
                    <div class="hourglass-container ic1-col-12">
                      <!-- <img
                      class="hourglass"
                      src="assets/images/redirect-icon.png" /> -->
                      <img
                        class="hourglass"
                        src="assets/images/hourglass.svg" />
                      <div
                        class="first-msg"
                        [HTMLTranslate]="
                          'RENEW_PAGE.SHOP_STEP.REDIRECT_TO_SHOP'
                        "></div>
                      <div
                        class="second-msg"
                        [HTMLTranslate]="'RENEW_PAGE.SHOP_STEP.WAIT'"></div>
                    </div>
                  </ng-template>
                </div>
              </ng-container>
            </ng-ui-kit-accordion>
          </div>
        </div>
      </div>
    </div>
    <!-- SPINNER PER LOGOUT FORZATO IN CASO MIGRATION TRUE -->
     <div *ngIf="showSpinner && (followMigrationFlow || automatic)">
      <div class="hourglass-container">
        <div class="forced-logout-spinner" aria-hidden="true"></div>
        <div class="forced-title" translate>
          RENEW_PAGE.SUCCESS_STEP.FORCE_LOGOUT.TITLE
        </div>
        <div
          class="first-msg"
          [innerHTML]="
            'RENEW_PAGE.SUCCESS_STEP.FORCE_LOGOUT.FIRST_MESSAGE' | translate
          "></div>
        <div class="second-msg" translate>
          RENEW_PAGE.SUCCESS_STEP.FORCE_LOGOUT.SECOND_MESSAGE
        </div>
      </div>
    </div>
  </ng-container>
</app-common-modal>
